import { useCompanyStore } from '@Stores/company.store';
import type { TrackingPayloadPrimitive, TrackingPayload } from '@Shared';

export type RequestContext = 'Send' | 'Payment';

export class TrackingPayloadBuilder {
    private payload: TrackingPayload;

    constructor(context: RequestContext = 'Send') {
        const companyStore = useCompanyStore();
        this.payload = {
            'Request Type': context,
            'Account Id': companyStore.company?.id ?? null,
            'Account Name': companyStore.company?.name ?? null,
        };
    }

    withPurposeType(purpose: string) {
        this.payload['Purpose type'] = purpose;
        return this;
    }

    withLocationName(location: string) {
        this.payload['Select account name'] = location;
        return this;
    }

    withTermsOfServiceViewed(termsViewed: boolean) {
        this.payload['Terms of service opened'] = termsViewed;
        return this;
    }

    withSupportLinkViewed(linkViewed: boolean) {
        this.payload['Support link clicked'] = linkViewed;
        return this;
    }

    withCustomField(label: string, value: TrackingPayloadPrimitive) {
        this.payload[label] = value;
        return this;
    }

    withPlaidBalance(linkViewed: boolean) {
        this.payload['Balance returned'] = linkViewed;
        return this;
    }

    withPlaidFailedReason(failedReason: string) {
        this.payload['Plaid result'] = failedReason;
        return this;
    }

    withNumberOfAccountsConnected(numberOfAccounts: number) {
        this.payload['Amount of accounts connected'] = numberOfAccounts;
        return this;
    }

    withNotesAddedFlag(hasNotes: boolean) {
        this.payload['Notes added'] = hasNotes;
        return this;
    }

    withNotes(notes: string|null) {
        this.payload['Notes description'] = notes ?? '';
        return this;
    }

    withHasFunds(hasFunds: boolean) {
        this.payload['Sufficient funds?'] = hasFunds;
        return this;
    }

    withViewedFeeHelp(viewedFeeHelp: boolean) {
        this.payload['Processing fee viewed'] = viewedFeeHelp;
        return this;
    }

    withModifiedFields(modifiedFields: string[]) {
        this.payload['Fields Modified'] = modifiedFields;
        return this;
    }

    withRecipientCount(recipientCount: number) {
        this.payload['Recipient count'] = recipientCount;
        return this;
    }

    withDigitalEligible(value: boolean) {
        this.payload['Digital Eligible'] = value;
        return this;
    }

    withDigitalVerificationFailed(value: boolean) {
        this.payload['Digital Verification Failed'] = value;
        return this;
    }

    withMppPurchased(value: boolean) {
        this.payload['MPP Purchased'] = value;
        return this;
    }

    withTransferAmountSelected(value: string) {
        this.payload['Transfer Amount Selected'] = value;
        return this;
    }

    build():TrackingPayload {
        return { ...this.payload };
    }
}
